export default __webpack_public_path__ + "static/media/comfort-zone.ce6ede07.png";